import { useMarkTravelEsimPlanLoaded } from '@/hooks/useTravelEsimOrderActions';
import { formatDateTime } from '@/lib/format';
import { Check, Loader2 } from 'lucide-react';

interface TravelEsimPlanLoadedButtonProps {
  orderId: string;
  itemId: string;
  planLoadedAt: string | null;
}

/**
 * Octave admin, recharge line: the plan is bought on the provider's tool
 * and loaded on the beneficiary's eSIM, then confirmed here, which e-mails
 * the beneficiary (resendable). No QR code to upload or send for a recharge.
 */
export function TravelEsimPlanLoadedButton({
  orderId,
  itemId,
  planLoadedAt,
}: TravelEsimPlanLoadedButtonProps) {
  const markLoaded = useMarkTravelEsimPlanLoaded(orderId);

  if (planLoadedAt) {
    return (
      <div className="flex flex-wrap items-center gap-x-3 gap-y-1 text-xs">
        <p className="flex items-center gap-1.5 text-emerald-700">
          <Check className="h-3.5 w-3.5" />
          Forfait chargé le {formatDateTime(planLoadedAt)}
        </p>
        <button
          type="button"
          onClick={() => markLoaded.mutate({ itemId, resend: true })}
          disabled={markLoaded.isPending}
          className="inline-flex items-center gap-1 text-slate-500 underline-offset-2 hover:text-slate-900 hover:underline disabled:opacity-60 cursor-pointer"
        >
          {markLoaded.isPending && <Loader2 className="h-3 w-3 animate-spin" />}
          Renvoyer l’e-mail
        </button>
      </div>
    );
  }

  return (
    <button
      type="button"
      onClick={() => markLoaded.mutate({ itemId })}
      disabled={markLoaded.isPending}
      className="inline-flex items-center gap-1.5 rounded-full bg-emerald-600 px-4 py-2 text-xs font-medium text-white shadow-sm transition-all hover:bg-emerald-700 hover:shadow-md disabled:opacity-60 cursor-pointer"
    >
      {markLoaded.isPending ? (
        <Loader2 className="h-3.5 w-3.5 animate-spin" />
      ) : (
        <Check className="h-3.5 w-3.5" />
      )}
      Forfait chargé sur l’eSIM
    </button>
  );
}
